<template>
  <div class="follow-order">
    <FilterPanel @apply="applyFilters">
      <div class="filter-field">
        <label for="visit-province">استان</label>
        <select id="visit-province" v-model="pickProvince" class="form-select" @change="getCityOnChange">
          <option value="">همه استان‌ها</option>
          <option v-for="province in provinceLists" :key="province.id" :value="province.id">{{ province.name }}</option>
        </select>
      </div>
      <div class="filter-field">
        <label for="visit-city">شهر</label>
        <select id="visit-city" v-model="pickCity" class="form-select" @change="getPromoterLists">
          <option value="">همه شهرها</option>
          <option v-for="city in cityLists" :key="city.city.id" :value="city.city.id">{{ city.city.name }}</option>
        </select>
      </div>
      <div class="filter-field">
        <label for="visit-category">نوع مشتری</label>
        <select id="visit-category" v-model="pickStore" class="form-select">
          <option value="">همه انواع</option>
          <option v-for="outlet in outletCat" :key="outlet.id" :value="outlet.id">{{ outlet.verbose_name }}</option>
        </select>
      </div>
      <div class="filter-field">
        <label for="visit-promoter">نیروی اجرایی</label>
        <select id="visit-promoter" v-model="pickPromoter" class="form-select">
          <option value="">همه نیروها</option>
          <option v-for="promoter in promoterLists" :key="promoter.id" :value="promoter.user.id">{{ person(promoter.user) }}</option>
        </select>
      </div>
      <div class="filter-field">
        <label for="visit-supervisor">سرپرست</label>
        <select id="visit-supervisor" v-model="pickSupervisor" class="form-select">
          <option value="">همه سرپرست‌ها</option>
          <option v-for="supervisor in superVisiorLists" :key="supervisor.id" :value="supervisor.user.id">{{ person(supervisor.user) }}</option>
        </select>
      </div>
      <div class="filter-field">
        <label for="visit-turn">نوبت</label>
        <input id="visit-turn" v-model="visitTurn" class="inputs" inputmode="numeric" placeholder="وارد کنید…" />
      </div>
      <div class="filter-field">
        <label for="visit-store-code">کد مشتری</label>
        <input id="visit-store-code" v-model="storeCode" class="inputs" dir="ltr" placeholder="وارد کنید…" />
      </div>
      <div class="filter-field">
        <label :for="'visit-range-' + _uid">بازه‌ی تاریخ ویزیت</label>
        <input :id="'visit-range-' + _uid" type="text" class="custom-input inputs" placeholder="انتخاب تاریخ" />
        <date-picker v-model="rangeDate" range clearable format="YYYY-MM-DDTHH:mm:00" display-format="jMMMM jD" :custom-input="'#visit-range-' + _uid" />
      </div>
      <div class="filter-field">
        <label :for="'visit-due-' + _uid">تاریخ اجرا</label>
        <input :id="'visit-due-' + _uid" type="text" class="custom-input inputs" placeholder="انتخاب تاریخ" />
        <date-picker v-model="dueDate" clearable format="YYYY-MM-DD" display-format="jMMMM jD" :custom-input="'#visit-due-' + _uid" />
      </div>
      <template #actions>
        <button type="submit" class="accept" :disabled="loadingList">اعمال فیلتر</button>
        <button type="button" class="remove-filtes" @click="removeFilter">پاک کردن فیلترها</button>
      </template>
    </FilterPanel>

    <div class="box list-box">
      <Tableview
        class="visit-table"
        :tableTitle="title"
        :recordCount="totalDataCount"
        :page="page"
        hover
        bordered
        :showNoContent="loadingList"
        :showNoData="!loadingList && dataPackage.length === 0"
        :errorMessage="listError"
        @retry="getDataPackage(20, 20 * (page - 1))"
      >
        <template #controls>
          <label class="ordering-title" :for="'visit-order-' + _uid">مرتب‌سازی</label>
          <b-form-select :id="'visit-order-' + _uid" v-model="selected" :options="options" class="ordering" value-field="item" text-field="name" @change="applyFilters" />
        </template>
        <template #footer>
          <pagination :disabled="loadingList" v-model="page" :per-page="20" :records="totalDataCount" @paginate="myCallback" />
        </template>

        <template #TableTitle>
          <tr>
            <th>ردیف</th>
            <th>فروشگاه</th>
            <th>نشانی</th>
            <th>نوع برنامه</th>
            <th>نیروی اجرایی</th>
            <th>سرپرست</th>
            <th>تاریخ ویزیت</th>
            <th>نوبت</th>
            <th>روز آخر</th>
            <th>امتیاز</th>
            <th>وضعیت</th>
            <th class="actions-column">عملیات</th>
          </tr>
        </template>

        <template #TableBody>
          <tr v-for="(item, index) in dataPackage" :key="item.id">
            <td class="persian-number">{{ 20 * (page - 1) + 1 + index }}</td>
            <td>
              <span class="cell-text cell-primary" :title="outlet(item).name">{{ outlet(item).name || '—' }}</span>
              <span class="cell-secondary"><span class="vn-mono">{{ outlet(item).code }}</span> · {{ (outlet(item).city || {}).name || '—' }}</span>
            </td>
            <td><span class="cell-text" :title="outlet(item).address">{{ outlet(item).address || '—' }}</span></td>
            <td>{{ (item.type || {}).verbose_name || '—' }}</td>
            <td>
              <span class="cell-primary">{{ person(item.promoter) || '—' }}</span>
              <span v-if="item.promoter" class="cell-secondary" dir="ltr">{{ item.promoter.username }}</span>
            </td>
            <td>{{ supervisorName(item) }}</td>
            <td><DisplayDate :value="item.start_datetime" showTime /></td>
            <td class="persian-number">{{ item.visit_turn === null || item.visit_turn === undefined ? '—' : item.visit_turn }}</td>
            <td><span class="flag" :class="{ on: item.is_last_day }">{{ item.is_last_day ? 'بله' : 'خیر' }}</span></td>
            <td>
              <span v-if="item.rate !== null && item.rate !== undefined" class="rate persian-number" :aria-label="'امتیاز ' + item.rate">★ {{ item.rate }}</span>
              <span v-else class="text-muted">—</span>
            </td>
            <td>
              <select v-if="editable" v-model="item.status" class="visit-status-select" :class="'visit-status-' + item.status" :disabled="statusBusy === item.id" :aria-label="'وضعیت ویزیت ' + outlet(item).name" @change="changeVisitStatus(item)">
                <option v-for="(label, value) in statuses" :key="value" :value="value">{{ label }}</option>
              </select>
              <button v-else type="button" class="visit-status-select visit-status-badge" :class="'visit-status-' + item.status" @click="visitDetail(item.id)">{{ statuses[item.status] || 'نامشخص' }}</button>
            </td>
            <td class="actions-cell">
              <RowActions :items="[
                { label: 'جزئیات ویزیت', icon: 'view', action: () => visitDetail(item.id) },
                { label: 'حذف ویزیت', icon: 'delete', action: () => askDelete(item), danger: true, hidden: !editable },
              ]" />
            </td>
          </tr>
        </template>
      </Tableview>
    </div>

    <b-modal v-model="deleteItemModal" title="حذف ویزیت" hide-footer centered header-close-label="بستن">
      <p>ویزیت «{{ deleteTarget && outlet(deleteTarget).name }}» حذف شود؟ این کار برگشت‌پذیر نیست.</p>
      <div class="d-flex justify-content-end mt-4">
        <button class="remove-filtes" :disabled="deleting" @click="deleteItemModal = false">انصراف</button>
        <button class="btn btn-danger" :disabled="deleting" @click="deleteItem">{{ deleting ? 'در حال حذف…' : 'حذف ویزیت' }}</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import DisplayDate from '@/components/DisplayDate/index.vue';
import FilterPanel from '@/components/FilterPanel/index.vue';
import Tableview from '@/components/Tableview/index.vue';
import Pagination from '@/components/ListPagination/index.vue';
import RowActions from '@/components/RowActions/index.vue';

const STATUSES = { 0: 'ویزیت نشده', 1: 'تکمیل نشده', 2: 'تکمیل شده', 3: 'تایید شده', 4: 'رد شده' };

// One list for every visit page: `status` pins the status filter, `editable` allows
// changing status and deleting, `detailRoute` chooses the report page that opens.
export default {
  name: 'VisitList',
  components: { DisplayDate, FilterPanel, Tableview, Pagination, RowActions },
  props: {
    title: { type: String, default: 'ویزیت‌ها' },
    status: { type: String, default: '' },
    editable: Boolean,
    detailRoute: { type: String, default: 'answerList' },
  },
  data() {
    return {
      loadingList: true,
      listError: '',
      dataPackage: [],
      cityLists: [],
      promoterLists: [],
      provinceLists: [],
      outletCat: [],
      superVisiorLists: [],
      pickCity: '',
      pickProvince: '',
      pickPromoter: '',
      pickStore: '',
      pickSupervisor: '',
      visitTurn: '',
      storeCode: '',
      dueDate: '',
      rangeDate: ['', ''],
      page: 1,
      totalDataCount: 0,
      selected: '-start_datetime',
      options: [
        { item: '-start_datetime', name: 'جدیدترین ویزیت' },
        { item: 'start_datetime', name: 'قدیمی‌ترین ویزیت' },
      ],
      statuses: STATUSES,
      statusBusy: null,
      deleteItemModal: false,
      deleteTarget: null,
      deleting: false,
    };
  },
  computed: {
    project() { return this.$STORE.state.userConfig.setProjectId; },
  },
  mounted() {
    this.getDataPackage();
    this.getCity();
    this.getPromoterLists();
    this.getProvince();
    this.getOutletCat();
    this.getSuperVisiorLists();
  },
  methods: {
    person(user) { return user ? [user.first_name, user.last_name].filter(Boolean).join(' ') : ''; },
    outlet(item) { return item.outlet || {}; },
    supervisorName(item) {
      const first = (item.supervisors || [])[0];
      return (first && this.person(first.supervisor)) || '—';
    },
    applyFilters() {
      this.page = 1;
      return this.getDataPackage();
    },
    getCityOnChange() {
      this.pickCity = '';
      this.getCity();
    },
    removeFilter() {
      Object.assign(this, { pickCity: '', pickPromoter: '', visitTurn: '', storeCode: '', pickProvince: '', pickStore: '', rangeDate: ['', ''], dueDate: '', pickSupervisor: '', page: 1 });
      this.getDataPackage();
      this.getCity();
      this.getPromoterLists();
    },
    async get(path) {
      return this.$ApiServiceLayer.get(path, this.$PATH.SERVICE_NAME.AUTH);
    },
    async getOutletCat() {
      const res = await this.get(this.$PATH.RELATIVE_PATH.GET.OUTLET_CAT + '?p=' + this.project);
      if (res.status === 200) this.outletCat = res.data;
    },
    async getSuperVisiorLists() {
      const res = await this.get(this.$PATH.RELATIVE_PATH.GET.ROLE_ASSIGNMENT + '?p=' + this.project + '&role__title_abbreviation=V');
      if (res.status === 200) this.superVisiorLists = res.data;
    },
    async getProvince() {
      const res = await this.get(this.$PATH.RELATIVE_PATH.GET.GET_PROVINCE_LIST + '?p=' + this.project);
      if (res.status === 200) this.provinceLists = res.data;
    },
    async getCity() {
      const res = await this.get(this.$PATH.RELATIVE_PATH.GET.GET_CITY_LIST + '?city__province=' + this.pickProvince + '&p=' + this.project);
      if (res.status === 200) this.cityLists = res.data;
    },
    async getPromoterLists() {
      const res = await this.get(this.$PATH.RELATIVE_PATH.GET.GET_PROMOTER_LIST + '?p=' + this.project + '&city=' + this.pickCity);
      if (res.status === 200) this.promoterLists = res.data;
    },
    async getDataPackage(limit = 20, offset = 0) {
      this.loadingList = true;
      this.listError = '';
      try {
        const [from, to] = this.rangeDate || [];
        // a single picked day covers the whole day
        const until = from && !to ? from.slice(0, 11) + '23:59:59' : to || '';
        const query = new URLSearchParams({
          status: this.status,
          outlet__city: this.pickCity,
          due_date: this.dueDate || '',
          outlet__city__province: this.pickProvince,
          promoter: this.pickPromoter,
          outlet__category: this.pickStore,
          outlet__code: this.storeCode,
          visit_turn: this.visitTurn,
          supervisor: this.pickSupervisor,
          limit,
          offset,
          ordering: this.selected,
          start_datetime__gte: from || '',
          start_datetime__lte: until,
          p: this.project,
          is_active: 'true',
        });
        const res = await this.get(this.$PATH.RELATIVE_PATH.GET.GET_VISIT_LIST + '?' + query);
        if (res.status !== 200) {
          this.listError = this.$ApiServiceLayer.getErrorMessage(res);
          return;
        }
        this.dataPackage = res.data.results;
        this.totalDataCount = res.data.count;
      } finally {
        this.loadingList = false;
      }
    },
    myCallback() {
      return this.getDataPackage(20, 20 * (this.page - 1));
    },
    visitDetail(id) {
      const routeData = this.$router.resolve({ name: this.detailRoute, params: { id } });
      window.open(routeData.href);
    },
    async changeVisitStatus(item) {
      this.statusBusy = item.id;
      try {
        const res = await this.$ApiServiceLayer.patch(
          this.$PATH.RELATIVE_PATH.MULTI.VISITS_STATUS + item.id + '/?p=' + this.project,
          this.$PATH.SERVICE_NAME.AUTH,
          { status: item.status, rejection_reason: item.status === '4' ? 'nadarad' : '' },
        );
        if (res.status === 200) this.$notify({ group: 'tc', type: 'success', text: 'وضعیت ویزیت به «' + STATUSES[item.status] + '» تغییر کرد.' });
        else {
          this.$notify({ group: 'tc', type: 'error', text: this.$ApiServiceLayer.getErrorMessage(res) });
          this.myCallback();
        }
      } finally {
        this.statusBusy = null;
      }
    },
    askDelete(item) {
      this.deleteTarget = item;
      this.deleteItemModal = true;
    },
    async deleteItem() {
      this.deleting = true;
      try {
        const res = await this.$ApiServiceLayer.delete(
          this.$PATH.RELATIVE_PATH.MULTI.VISIT_DETAIL_EDIT + this.deleteTarget.id + '/?p=' + this.project,
          this.$PATH.SERVICE_NAME.AUTH,
          {},
        );
        if (res.status === 204) {
          this.deleteItemModal = false;
          this.$notify({ group: 'tc', type: 'success', text: 'ویزیت حذف شد.' });
          this.myCallback();
        } else this.$notify({ group: 'tc', type: 'error', text: this.$ApiServiceLayer.getErrorMessage(res) });
      } finally {
        this.deleting = false;
      }
    },
  },
};
</script>

<style scoped>
.flag { display: inline-block; padding: 1px 8px; border-radius: 3px; font-size: 12px; background: var(--surface-sunken); color: var(--text-3); }
.flag.on { background: var(--amber-50); color: var(--amber-700); font-weight: 800; }
.rate { color: var(--amber-700); font-weight: 800; white-space: nowrap; }
</style>
